import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LegalLinkMap } from '@core/constants/legal-links.constants';
import { environment } from '@env';
import { TranslocoDirective } from '@jsverse/transloco';
import { NzFooterComponent } from 'ng-zorro-antd/layout';

@Component({
  selector: 'aad-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.less',
  imports: [NzFooterComponent, TranslocoDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  public currentYear = new Date().getFullYear(); // Dynamically gets the current year

  public frontendVersion = environment.version;

  protected readonly legalLinks = LegalLinkMap;
}
